'use client'

import Script from 'next/script';
import { useEffect, useState } from 'react';

import { useUserStore } from '@utils/user';

declare let fbq: any;

const enableAnalytics = process.env.NEXT_PUBLIC_ANALYTICS === 'true' ? true : false;

interface FBPixelProps {
  event: string;
  id?: string | number;
  values: any
}

export default function FBPixelScript({ event, id, values }: FBPixelProps) {

  const [isFacebookPixelPresent, setIsFacebookPixelPresent] = useState(false);
  const userStore = useUserStore();
  const userInfo = userStore.getUserInfoForAnalytics();

  const valuesWithUserInfo = {
    ...values,
    ...userInfo
  }

  const scriptId = `FB-Pixel-Event-${event}${id ? '-' + id : ''}`

  useEffect(() => {
    if (userStore.isReady) {
      checkFBQ();
    }
  }, [userStore.isReady])

  const checkFBQ = () => {
    if (typeof fbq === 'undefined' || !userStore.isReady) {
      setTimeout(checkFBQ, 2000);
    } else {
      setIsFacebookPixelPresent(true);
    }
  }

  useEffect(() => {
    setTimeout(() => {
      checkFBQ();
    }, 10);
  }, [userStore.isReady])

  return (
    <>
      {enableAnalytics && isFacebookPixelPresent && (
        <Script
          id={scriptId}
          dangerouslySetInnerHTML={{
            __html: `fbq('track', '${event}', ${JSON.stringify(valuesWithUserInfo)});`,
          }}
        />
      )}
    </>
  );
}
